export default __webpack_public_path__ + "static/media/icon-activity-video.40dd429c.svg";